import React from 'react';
import {useRegFormsContext} from '../RegFormsContext';
import {useIntl} from "react-intl";
import RegFormsLink from "../RegFormsLink";

export type Item = {
  key: number
  status: boolean
  name: string
  defaultLabel: string
  defaultText: string
  link?: string
  disabled?: boolean
}

const RegFormsLinksContainer = () => {
  const {status, form101FileStatus, taxAdjustmentFileStatus} = useRegFormsContext();
  const intl = useIntl();

  const links: Item[] = [
    {
      key: 0,
      status: status.personalInfo.filled,
      name: 'personal-info',
      defaultLabel: 'Personal information',
      defaultText: 'Here you can update all the personal information you provided on registration',
      link: status.personalInfo.link
    },
    {
      key: 1,
      status: status.contract.filled,
      name: 'contract',
      defaultLabel: 'Contractual agreement',
      defaultText: 'A contract between you and Atzmai Sachir company',
      link: status.contract.link,
      disabled: !status.personalInfo.filled
    },
    {
      key: 2,
      status: status.form6101.filled,
      name: 'form-6101',
      defaultLabel: 'Form 6101',
      defaultText: 'A form required for national insurance',
      link: status.form6101.link,
      disabled: !status.personalInfo.filled
    },
    {
      key: 3,
      status: form101FileStatus.exists,
      name: 'form-101',
      defaultLabel: 'Form 101',
      defaultText: 'A form for the employee to declare personal information and report additional income for the purpose of income tax',
      link: status.form101.link,
      disabled: !status.personalInfo.filled
    },
    {
      key: 4,
      status: taxAdjustmentFileStatus.exists,
      name: 'form-tax-adjustment',
      defaultLabel: 'Form tax adjustment',
      defaultText: '',
      link: status.taxAdjustment.link
    },
  ];

  return (
    <>
        {links.map((item: Item) => {
          return (
            <RegFormsLink
              key={item.key}
              status={item.status}
              label={intl.formatMessage({
                id: `regForms-link-${item.name}-label`,
                defaultMessage: `${item.defaultLabel}`
              })}
              text={intl.formatMessage({
                id: `regForms-link-${item.name}-text`,
                defaultMessage: `${item.defaultText}`
              })}
              link={item.link || '/'}
              disabled={item.disabled}
            />
          )
        })}
    </>
  );
};

export default RegFormsLinksContainer;
